/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-25 21:40:02
 * @LastEditors: wuzuojie 15727841808@163.com
 * @LastEditTime: 2023-07-31 09:47:12
 */
// import Home from "@/views/home/home";
import home from '@/views/homePage/home';
import { ControlLayout } from '@/components/layout';

const normalRoutes = [
	{
		path: '/index',
		component: null,
		name: '工作台',
		redirect: '/index/home',
		id: 1,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		useTemplate: false,
		children: [
			{
				path: 'home',
				component: 'homePage/home',
				name: 'home',
				parentId: 1,
				showBread: false,
				useTemplate: false,
				visible: false,
				children: null,
			},
		],
	},
];
export default normalRoutes;
